export default __webpack_public_path__ + "static/media/hamam.793f58be.png";